import "../stakeholderlayout.css";

export default function Design() {
  return (
    <div className="pillar-section">
      <div className="pillar-header">
        <span className="emoji">🔷</span>
        <h2>STEP 2: DESIGN & STRATEGY</h2>
        <span className="subtitle">Translate Diagnosis into Institutional Architecture</span>
      </div>

      <div className="pillar-content">
        <h3>Purpose</h3>
        <p>
          To convert insights from diagnosis into structured solutions that are feasible, aligned with
          governance realities, and capable of long-term sustainability.
        </p>

        <h3>Why This Step Matters</h3>
        <p>
          Many strategies fail because they are not grounded in institutional realities or governance
          constraints. A viable design must align with incentives, capacities, and accountability
          structures.
        </p>

        <h3>What We Design</h3>
        <ul>
          <li>Target operating model</li>
          <li>Governance architecture</li>
          <li>Strategic roadmap</li>
          <li>Implementation frameworks</li>
          <li>Monitoring & evaluation systems</li>
        </ul>

        <h3>Design Principles</h3>
        <ul>
          <li>Feasibility over idealism</li>
          <li>Alignment with institutional incentives</li>
          <li>Scalability and adaptability</li>
          <li>Accountability and transparency</li>
        </ul>

        <h3>Outputs</h3>
        <ul>
          <li>Strategy blueprint</li>
          <li>Governance charter</li>
          <li>Implementation roadmap</li>
          <li>Operating model</li>
        </ul>

        <div className="cta">
          <a href="/approach/design-strategy" className="learn-more">
            Click → Deep Page
            <span className="arrow">👉</span>
          </a>
        </div>
      </div>
    </div>
  );
}